import { unflattenAssign } from 'utilities';
import * as actions from 'actions/payments';

const initialState = {
  invoiced: false,
  currency: 'USD',
  fetching: false,
  fetched: false,
  allowFetchRetry: false,
  adyen: {
    isConnected: false,
    connectionError: '',
    currency: 'USD',
    formDetailsError: '',
    pollingForDetailConfirmation: false,
    type: '',
    detail: {
      paymentMethod: '',
      cardNumber: '',
    },
  },
};

const ADYEN_INVOICE_KEY = 'INVOICE';

export default function payments(state = initialState, action) {
  switch (action.type) {
    case actions.PAYMENT_INFO_FETCHED:
      return unflattenAssign('fetched', true, state);

    case actions.FETCHING_PAYMENT_INFO:
      return unflattenAssign('fetching', true, state);

    case actions.FETCHING_PAYMENT_INFO_STOPPED:
      return unflattenAssign('fetching', false, state);

    case actions.ALLOW_FETCH_RETRY:
      return unflattenAssign('allowFetchRetry', true, state);

    case actions.DISALLOW_FETCH_RETRY:
      return unflattenAssign('allowFetchRetry', false, state);

    case actions.ADYEN_RECURRING_DETAIL_RECEIVED:
      return {
        ...state,
        invoiced: action.payload.type === ADYEN_INVOICE_KEY,
        adyen: {
          ...state.adyen,
          isConnected: true,
          // In case we had a previous connection error and we retried fetching
          connectionError: '',
          type: action.payload.type,
          detail: {
            ...state.adyen.detail,
            ...action.payload.detail,
          },
        },
      };

    case actions.ADYEN_RECURRING_DETAIL_RECEIVED_FAILED:
      return {
        ...state,
        adyen: {
          ...state.adyen,
          isConnected: false,
          connectionError: action.err.message,
        },
      };

    case actions.ADYEN_HPP_FORM_DETAILS_FAILED:
      return {
        ...state,
        adyen: {
          ...state.adyen,
          formDetailsError: action.err.message,
        },
      };

    case actions.ADYEN_RECURRING_DETAIL_RECEIVED_FAILED_SYSTEM_ERROR:
      return {
        ...state,
        adyen: {
          ...state.adyen,
          isConnected: false,
          connectionError: action.err.message,
          systemError: true,
        },
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/payments.js